/**
 * Enum of permission status.
 */
export var PermissionStatus;
(function (PermissionStatus) {
    /**
     * Permission is granted.
     */
    PermissionStatus["Granted"] = "granted";
    /**
     * Permission is denied.
     */
    PermissionStatus["Denied"] = "denied";
    /**
     * Permission has not yet been requested.
     */
    PermissionStatus["NotDetermined"] = "not_determined";
})(PermissionStatus || (PermissionStatus = {}));
/**
 * Fallback when prompting for permission and the permission is
 * already denied on iOS or is denied silently on Android.
 */
export var PromptPermissionFallback;
(function (PromptPermissionFallback) {
    /**
     * Take the user to the system settings to enable the permission.
     */
    PromptPermissionFallback["SystemSettings"] = "systemSettings";
})(PromptPermissionFallback || (PromptPermissionFallback = {}));
/**
 * iOS options
 */
export var iOS;
(function (iOS) {
    /**
     * Enum of notification options. iOS only.
     */
    let NotificationOption;
    (function (NotificationOption) {
        /**
         * Alerts.
         */
        NotificationOption["Alert"] = "alert";
        /**
         * Sounds.
         */
        NotificationOption["Sound"] = "sound";
        /**
         * Badges.
         */
        NotificationOption["Badge"] = "badge";
        /**
         * Car play.
         */
        NotificationOption["CarPlay"] = "car_play";
        /**
         * Critical Alert.
         */
        NotificationOption["CriticalAlert"] = "critical_alert";
        /**
         * Provides app notification settings.
         */
        NotificationOption["ProvidesAppNotificationSettings"] = "provides_app_notification_settings";
        /**
         * Provisional.
         */
        NotificationOption["Provisional"] = "provisional";
    })(NotificationOption = iOS.NotificationOption || (iOS.NotificationOption = {}));
    /**
     * Enum of foreground notification options.
     */
    let ForegroundPresentationOption;
    (function (ForegroundPresentationOption) {
        /**
         * Play the sound associated with the notification.
         */
        ForegroundPresentationOption["Sound"] = "sound";
        /**
         * Apply the notification's badge value to the app’s icon.
         */
        ForegroundPresentationOption["Badge"] = "badge";
        /**
         * Show the notification in Notification Center. On iOS 13 an older,
         * this will also show the notification as a banner.
         */
        ForegroundPresentationOption["List"] = "list";
        /**
         * Present the notification as a banner. On iOS 13 an older,
         * this will also show the notification in the Notification Center.
         */
        ForegroundPresentationOption["Banner"] = "banner";
    })(ForegroundPresentationOption = iOS.ForegroundPresentationOption || (iOS.ForegroundPresentationOption = {}));
    /**
     * Enum of authorized notification options.
     */
    let AuthorizedNotificationSetting;
    (function (AuthorizedNotificationSetting) {
        /**
         * Alerts.
         */
        AuthorizedNotificationSetting["Alert"] = "alert";
        /**
         * Sounds.
         */
        AuthorizedNotificationSetting["Sound"] = "sound";
        /**
         * Badges.
         */
        AuthorizedNotificationSetting["Badge"] = "badge";
        /**
         * CarPlay.
         */
        AuthorizedNotificationSetting["CarPlay"] = "car_play";
        /**
         * Lock screen.
         */
        AuthorizedNotificationSetting["LockScreen"] = "lock_screen";
        /**
         * Notification center.
         */
        AuthorizedNotificationSetting["NotificationCenter"] = "notification_center";
        /**
         * Critical alert.
         */
        AuthorizedNotificationSetting["CriticalAlert"] = "critical_alert";
        /**
         * Announcement.
         */
        AuthorizedNotificationSetting["Announcement"] = "announcement";
        /**
         * Scheduled delivery.
         */
        AuthorizedNotificationSetting["ScheduledDelivery"] = "scheduled_delivery";
        /**
         * Time sensitive.
         */
        AuthorizedNotificationSetting["TimeSensitive"] = "time_sensitive";
    })(AuthorizedNotificationSetting = iOS.AuthorizedNotificationSetting || (iOS.AuthorizedNotificationSetting = {}));
    /**
     * Enum of authorized status.
     */
    let AuthorizedNotificationStatus;
    (function (AuthorizedNotificationStatus) {
        /**
         * Not determined.
         */
        AuthorizedNotificationStatus["NotDetermined"] = "not_determined";
        /**
         * Denied.
         */
        AuthorizedNotificationStatus["Denied"] = "denied";
        /**
         * Authorized.
         */
        AuthorizedNotificationStatus["Authorized"] = "authorized";
        /**
         * Provisional.
         */
        AuthorizedNotificationStatus["Provisional"] = "provisional";
        /**
         * Ephemeral.
         */
        AuthorizedNotificationStatus["Ephemeral"] = "ephemeral";
    })(AuthorizedNotificationStatus = iOS.AuthorizedNotificationStatus || (iOS.AuthorizedNotificationStatus = {}));
})(iOS || (iOS = {}));
/**
 * Enum of authorized Features.
 */
export var Feature;
(function (Feature) {
    Feature["InAppAutomation"] = "in_app_automation";
    Feature["MessageCenter"] = "message_center";
    Feature["Push"] = "push";
    // No longer used
    Feature["Chat"] = "chat";
    Feature["Analytics"] = "analytics";
    Feature["TagsAndAttributes"] = "tags_and_attributes";
    Feature["FeatureFlags"] = "feature_flags";
    Feature["Contacts"] = "contacts";
    // No longer used
    Feature["Location"] = "location";
})(Feature || (Feature = {}));
/**
 * All available features.
 */
export const FEATURES_ALL = Object.values(Feature);
/**
 * Subscription Scope types.
 */
export var SubscriptionScope;
(function (SubscriptionScope) {
    SubscriptionScope["App"] = "app";
    SubscriptionScope["Web"] = "web";
    SubscriptionScope["Sms"] = "sms";
    SubscriptionScope["Email"] = "email";
})(SubscriptionScope || (SubscriptionScope = {}));
//# sourceMappingURL=types.js.map